var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bim-text',{staticClass:"text-center",attrs:{"type":_vm.type,"bold":_vm.bold}},[_vm._v(_vm._s(_vm.$t(_vm.template, { count: _vm.our_model_count })))])
}
var staticRenderFns = []

export { render, staticRenderFns }